import * as React from "react";

import { ChibiKeeper } from "./KeeperArt.jsx";
export { ChibiKeeper } from "./KeeperArt.jsx";

export function PenaltyScene({ animation, round, keeper = "gojo", accent = "#aa8cff", children }) {
  const scene = React.useRef(null);
  React.useEffect(() => {
    const element = scene.current;
    const resize = () => {
      element.style.setProperty('--scene-width', `${element.clientWidth}px`);
      element.style.setProperty('--scene-height', `${element.clientHeight}px`);
    };
    resize();
    const observer = new ResizeObserver(resize);
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  const direction = animation?.direction || "left";
  const keeperDirection = animation?.event === "save" ? direction : direction === "left" ? "right" : "left";
  const mood = animation?.event || (round?.status === "lost" ? "save" : "ready");
  return (
    <div ref={scene} style={{ "--keeper-accent": accent }} className={`penalty-scene ${animation ? "penalty-shot" : ""} penalty-ball-${direction} penalty-dive-${keeperDirection} penalty-event-${mood}`}>
      <div className="penalty-stadium"><i /><i /><i /></div>
      <div className="penalty-pitch"><div className="penalty-box-line" /><div className="penalty-center-line" /></div>
      <div className="penalty-goal"><div className="penalty-net" /></div>
      <div className="penalty-keeper" key={keeper}><ChibiKeeper mood={mood} keeper={keeper} /></div>
      <div className="penalty-ball" key={animation?.id || "ready"} aria-hidden="true">
        <svg viewBox="0 0 64 64"><circle cx="32" cy="32" r="29" fill="#f6f5ff" stroke="#98acc8" strokeWidth="2" /><path d="m32 20 12 9-5 14H25l-5-14Zm0-17 9 5-4 8H27l-4-8M4 27l8-6 7 7-4 10-10-1m54-10-8-6-7 7 4 10 10-1M17 56l1-10 10-1 4 10-6 6m21-5-1-10-10-1-4 10 6 6" fill="#243047" /></svg>
      </div>
      {animation && <div className="penalty-shot-caption" role="status">{mood === "save" ? "СЕЙВ!" : "ГОЛ!"}</div>}
      {animation && <div className="penalty-reaction"><ChibiKeeper mood={mood} keeper={keeper} /></div>}
      {children}
    </div>
  );
}
